module.exports = __webpack_public_path__ + "static/tobi-4f725a72257ddd1030cd0d7cddea04e2.png";